import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleInput from "../../../modules/SimpleInput";
import {Status} from "../../common/Constants";
import Api from "../../../Services/Api";
import {mapToObjectDDL} from "../../common/mapper";

class MasterLeasingFilter extends Component {
    statusOptions = [
        {
            label: Status.ACTIVE,
            value: Status.ACTIVE,
        },
        {
            label: Status.INACTIVE,
            value: Status.INACTIVE,
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            provinceOptions: [],
            cabangOptions: [],
        };
    }

    async componentDidMount() {
        const responses = await Promise.all([
            Api.create("NAGAMAS_MASTER_DATA").getAllProvince(),
            Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang(),
        ]);

        if (responses[0].ok && !R.isEmpty(responses[0].data.data)) {
            this.setState((prevValue) => ({
                ...prevValue,
                provinceOptions: responses[0].data.data.map((option) =>
                    mapToObjectDDL(option.provinceName, option.id)
                ),
            }));
        }

        if (responses[1].ok && !R.isEmpty(responses[1].data.data)) {
            this.setState((prevValue) => ({
                ...prevValue,
                cabangOptions: responses[1].data.data.map((c) =>
                    mapToObjectDDL(c.namaDealer, c.kodeCabang)
                ),
            }));
        }
    }

    handleValueChange = (name, value) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
            },
        }));
    };

    handleTextChange = ({target}) => {
        this.handleValueChange(target.name, target.value);
    };

    handleDDLChange = (value, {name}) => {
        this.handleValueChange(name, value);
    };

    handleChangeProvince = async (value, {name}) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
                kota: null,
                kecamatan: null,
                kodePos: null,
            },
        }));
        if (!R.isNil(value)) {
            try {
                const response = await Api.create("NAGAMAS_MASTER_DATA").getAllCity(value.value);
                if (response.ok) {
                    this.props.onSetState((prevValue) => ({
                        ...prevValue,
                        kotaOptions: response.data.data.map((option) =>
                            mapToObjectDDL(option.kabKotName, option.kabKotId)
                        ),
                    }));
                }
            } catch (error) {
                // TODO
            }
        }
    };

    handleChangeKota = async (value, {name}) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
                kecamatan: null,
                kodePos: null,
            },
        }));
        if (!R.isNil(value)) {
            try {
                const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKecamatan(value.value);
                if (response.ok) {
                    this.props.onSetState((prevValue) => ({
                        ...prevValue,
                        kecamatanOptions: response.data.data.map((option) =>
                            mapToObjectDDL(option.kecamatanName, option.id)
                        ),
                    }));
                }
            } catch (error) {
                // TODO
            }
        }
    };

    handleChangeKecamatan = async (value, {name}) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
                kodePos: null,
            },
        }));
        if (!R.isNil(value)) {
            try {
                const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKelurahan(value.value);
                if (response.ok) {
                    this.props.onSetState((prevValue) => ({
                        ...prevValue,
                        kelurahanOptions: response.data.data.map((option) => ({
                            ...mapToObjectDDL(`${option.zipcode} - ${option.kelurahanname}`, option.zipcode),
                            kelurahanId: option.id,
                        })),
                    }));
                }
            } catch (error) {
                // TODO
            }
        }
    };

    handleResetFilter = () => {
        this.props.onSetState((prevValue) => ({...prevValue, filterData: {}}));
    };

    getDataValue = (fieldName, fallbackValue = "") => {
        return !R.isNil(this.props.state.filterData) && this.props.state.filterData[fieldName]
            ? this.props.state.filterData[fieldName]
            : fallbackValue;
    };

    render() {
        return (
            <SimpleModal
                title="Filter Search"
                visible={this.props.state.filterVisible}
                onClickClose={this.props.onClickClose}
                content={
                    <ModalContainer>
                        <SimpleInput
                            id="input_text_id"
                            name="leasingId"
                            label="ID"
                            value={this.getDataValue("leasingId")}
                            onChange={this.handleTextChange}
                        />
                        <SimpleInput
                            id="input_text_nama_leasing"
                            name="leasingName"
                            label="Nama Leasing"
                            value={this.getDataValue("leasingName")}
                            onChange={this.handleTextChange}
                        />
                        <SimpleInput
                            id="input_text_nama_singkatan_leasing"
                            name="abbreviatedName"
                            label="Nama Singkatan"
                            value={this.getDataValue("abbreviatedName")}
                            onChange={this.handleTextChange}
                        />
                        <SimpleDDL
                            id="select_options_provinsi"
                            box="search"
                            label="Provinsi"
                            name="provinceId"
                            isClearable
                            options={this.state.provinceOptions}
                            value={this.getDataValue("provinceId", null)}
                            onChange={this.handleChangeProvince}
                        />
                        <SimpleDDL
                            id="select_options_kota"
                            box="search"
                            label="Kota"
                            name="kabkotId"
                            isClearable
                            options={this.props.state.kotaOptions}
                            readOnly={R.isNil(this.getDataValue("provinceId", null))}
                            value={this.getDataValue("kabkotId", null)}
                            onChange={this.handleChangeKota}
                        />
                        <SimpleDDL
                            id="select_options_kecamatan"
                            box="search"
                            label="Kecamatan"
                            name="kecamatanId"
                            isClearable
                            options={this.props.state.kecamatanOptions}
                            readOnly={R.isNil(this.getDataValue("kabkotId", null))}
                            value={this.getDataValue("kecamatanId", null)}
                            onChange={this.handleChangeKecamatan}
                        />
                        <SimpleDDL
                            id="select_options_kode_pos"
                            name="zipCode"
                            label="Kode Pos"
                            box="search"
                            isClearable
                            readOnly={R.isNil(this.props.state.filterData.kecamatanId)}
                            options={this.props.state.kelurahanOptions}
                            value={this.getDataValue("zipCode", null)}
                            onChange={this.handleDDLChange}
                        />
                        <SimpleDDL
                            id="select_options_oleh_cabang"
                            name="listKodeCabang"
                            label="Diakses Oleh Cabang"
                            box="multiselect"
                            options={this.state.cabangOptions}
                            value={this.getDataValue("listKodeCabang", null)}
                            onChange={this.handleDDLChange}
                        />
                        <SimpleDDL
                            id="select_options_status"
                            name="status"
                            label="Status"
                            box="search"
                            isClearable
                            options={this.statusOptions}
                            value={this.getDataValue("status", null)}
                            onChange={this.handleDDLChange}
                        />
                        <FlexView hAlignContent="right">
                            <SimpleButton type="button" secondary onClick={this.handleResetFilter}>
                                Hapus
                            </SimpleButton>
                            <SimpleButton onClick={this.props.onSubmit}>Terapkan</SimpleButton>
                        </FlexView>
                    </ModalContainer>
                }
            />
        );
    }
}

export default MasterLeasingFilter;
